import { Rating } from "@material-ui/lab";
import CheckmarkIcon from "assets/svgs/CheckmarkIcon";
import REVIEWS_DATA from "components/NewHomepage/data/REVIEWS_DATA";
import config from "config";
import Image from "next/image";

const JoinTheCommunity: React.FC = () => (
	<div className="flex flex-col md:flex-row">
		{/* Green section */}
		<div className="w-full bg-green-500 px-4 pb-[48px] pt-[72px] md:w-[38%] md:min-w-[512px] md:px-[100px] md:py-[72px] ">
			<img
				alt="user review"
				className="mx-auto w-[64px] md:mx-0 md:w-[100px]"
				src="https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/inverted-quote.png"
			/>

			<h3 className="my-6 text-center text-[24px] font-bold leading-[40px] text-white md:my-[56px] md:text-left md:text-[32px] md:leading-[48px]">
				Join the community of 5 crore satisfied job seekers...
			</h3>

			<p className="m-0 flex items-center justify-center text-md text-white md:justify-start">
				Play Store Ratings{" "}
				<Rating
					className="ml-2 inline"
					defaultValue={4.5}
					readOnly
					precision={0.5}
					classes={{ iconEmpty: "[&>svg]:fill-[#fff]" }}
				/>
			</p>
		</div>

		{/* Reviews section */}
		<div className="scrollbarHide relative flex grow items-stretch overflow-scroll bg-[#EAF8F4] py-[40px] md:py-[80px] md:pl-6">
			{/* <Marquee speed={40}> */}
			{data.map((i) => (
				<div className="my-[42px] mr-6 w-[calc(100vw-48px)] shrink-0 rounded-2xl border bg-white px-4 pb-4 pt-4 shadow-200 md:mr-[48px] md:w-[500px] md:px-6 md:pb-6 md:pt-4">
					<div className="flex items-end">
						<div className="absolute h-[94px] w-[84px] overflow-hidden rounded-2xl">
							<Image
								alt="User review"
								src={i.image}
								objectFit="cover"
								layout={"fill"}
								className="object-cover"
							/>
						</div>

						<div className="ml-[108px]">
							<div className="flex items-center  text-md font-semibold">
								{i.name}{" "}
								<span className="ml-3 inline-flex items-center rounded-md border p-1 text-xs leading-[16px] text-green-500">
									<span className="p-[3px][&>svg]:h-[8px] mr-1 inline-flex h-3 w-3 items-center justify-center rounded-full bg-green-500 [&>svg]:w-[8px]">
										<CheckmarkIcon
											fill="#fff"
											className="fill-green-500"
										/>
									</span>
									PLACED
								</span>
							</div>
							{/* <p className="m-0 text-sm text-[#8C8594] md:text-md">
								{i.designation}
							</p> */}
							<p className="m-0 flex items-center text-md font-semibold">
								{i.rating}{" "}
								<Rating
									size="small"
									defaultValue={i.rating}
									readOnly
									precision={0.1}
									classes={{ iconEmpty: "[&>svg]:fill-[#E8E7EA]" }}
									className="ml-2 inline !text-[20px]"
								/>
							</p>
						</div>
					</div>
					<p className="mb-0 mt-6 text-md">{i.review}</p>
				</div>
			))}
			{/* </Marquee> */}
		</div>
	</div>
);

export default JoinTheCommunity;

// const data = [
// 	{
// 		image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR99xOg-TEgWSQ4i-Sizo0P3VCGolkrRh8d_g&usqp=CAU",
// 		name: "Hritik Arthur",
// 		designation: "Associate at Reliance Jio Pvt. Ltd.",
// 		review: "For digital marketing role, I was getting jobs in other cities but not in my hometown, Hyderabad. Using Apna app, I spoke to the HR directly and scheduled my interview that helped me in getting a job in my hometown",
// 		rating: 4.5,
// 	},
// 	{
// 		image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR99xOg-TEgWSQ4i-Sizo0P3VCGolkrRh8d_g&usqp=CAU",
// 		name: "Hritik Arthur",
// 		designation: "Associate at Reliance Jio Pvt. Ltd.",
// 		review: "Good and helpful app, even for freshers who don't have good qualifications. There are jobs for Caretakers, House help and many more. It's very easy to find jobs here. Thank you! Good and helpful app, even for freshers who don't have good qualifications. There are jobs for Caretakers, House help and many more. It's very easy to find jobs here.",
// 		rating: 3.9,
// 	},
// 	{
// image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR99xOg-TEgWSQ4i-Sizo0P3VCGolkrRh8d_g&usqp=CAU",
// name: "Hritik Arthur",
// designation: "Associate at Reliance Jio Pvt. Ltd.",
// review: "Good and helpful app, even for freshers who don't have good qualifications. There are jobs for Caretakers, House help and many more. It's very easy to find jobs here. Thank you! Good and helpful app, even for freshers who don't have good qualifications. There are jobs for Caretakers, House help and many more. It's very easy to find jobs here.",
// rating: 4.2,
// 	},
// 	{
// 		image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR99xOg-TEgWSQ4i-Sizo0P3VCGolkrRh8d_g&usqp=CAU",
// 		name: "Hritik Arthur",
// 		designation: "Associate at Reliance Jio Pvt. Ltd.",
// 		review: "Good and helpful app, even for freshers who don't have good qualifications. There are jobs for Caretakers, House help and many more. It's very easy to find jobs here. Thank you! Good and helpful app, even for freshers who don't have good qualifications. There are jobs for Caretakers, House help and many more. It's very easy to find jobs here.",
// 		rating: 4.0,
// 	},
// ];

const data = REVIEWS_DATA.map((i) => ({
	image: config.gumletBaseUrl + i.imgURL,
	name: i.author,
	designation: "Associate at Reliance Jio Pvt. Ltd.",
	review: i.details,
	rating: 4.5,
}));
